<form [formGroup]="skillsForm" (ngSubmit)="onSubmit()">
 
    <p>
      <label for="name">Name </label>
      <input type="text" id="name" name="name" formControlName="name">
    </p>
   
   
    Skills:
    <div formArrayName="skills">
      <div *ngFor="let skill of skills.controls; let i=index">
        <div [formGroupName]="i">
          {{i}}
          skill name :
          <input type="text" formControlName="skill">
          exp:
          <input type="text" formControlName="exp">
   
          <button (click)="removeSkill(i)">Remove</button>
        </div>
      </div>
    </div>
   
    <p>
      <button type="submit">Submit</button>
    </p>
   
  </form>
   
   
  <p>
    <button type="button" (click)="addSkills()">Add</button>
  </p>
   
  {{this.skillsForm.value | json}}